var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.288 46.288c.21.21.211.552-.004.757a22.001 22.001 0 1 1 0-31.865.528.528 0 0 1 .005.757.55.55 0 0 1-.767.005 20.924 20.924 0 1 0 0 30.342.55.55 0 0 1 .767.005Z",
    fill: "#3F6AFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.165 43.304a.48.48 0 0 1-.005.69 17.86 17.86 0 1 1 0-25.945.48.48 0 0 1 .005.69.503.503 0 0 1-.7.005 16.879 16.879 0 1 0 0 24.555.503.503 0 0 1 .7.005Z",
    fill: "#D2B725"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.883 40.344a.458.458 0 0 1-.005.66 13.526 13.526 0 1 1 0-19.783c.19.178.19.476.005.66a.484.484 0 0 1-.671.006 12.585 12.585 0 1 0 0 18.45.485.485 0 0 1 .671.007Z",
    fill: "#F244CC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.987 37.217a.473.473 0 0 1-.01.688 9.126 9.126 0 1 1 0-13.585.473.473 0 0 1 .01.688.517.517 0 0 1-.708.01 8.138 8.138 0 0 0-13.537 6.095 8.14 8.14 0 0 0 13.537 6.093.517.517 0 0 1 .708.011Z",
    fill: "#2FCF49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__a",
    x: 7.596,
    y: 7.596,
    width: 40.367,
    height: 47.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.379
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.415686 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.758
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.415686 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_109_3920",
    result: "effect2_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_109_3920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__b",
    x: 9.654,
    y: 9.793,
    width: 37.022,
    height: 42.457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.842
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.823529 0 0 0 0 0.717647 0 0 0 0 0.145098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.684
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.823529 0 0 0 0 0.717647 0 0 0 0 0.145098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_109_3920",
    result: "effect2_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_109_3920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__c",
    x: 14.547,
    y: 15.008,
    width: 28.052,
    height: 32.209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.645
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.94902 0 0 0 0 0.266667 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.289
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.94902 0 0 0 0 0.266667 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_109_3920",
    result: "effect2_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_109_3920",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__d",
    x: 18.471,
    y: 18.701,
    width: 21.945,
    height: 24.822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.821
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.184314 0 0 0 0 0.811765 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.643
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.184314 0 0 0 0 0.811765 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_109_3920",
    result: "effect2_dropShadow_109_3920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_109_3920",
    result: "shape"
  })))));
};
export default SvgLogo;